import {
    SET_LAST_SEARCH_CRITERIA,
    SET_LAST_SEARCH_CRITERIA_ERROR
} from "./types";

export function setLastSearchCriteria(criteria) {
    return function (dispatch) {
        try {
            dispatch(
                {
                    type: SET_LAST_SEARCH_CRITERIA,
                    payload: criteria
                }
            )           
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: SET_LAST_SEARCH_CRITERIA_ERROR,
                });
            }
        }
    };
}